import React from 'react'
import { withFormik } from 'formik'
import { isEmpty } from 'lodash'
import { compose } from 'recompose'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'

const SigninBox = ({
  values,
  errors,
  isValid,
  onSubmit,
  handleChange,
  handleBlur,
  handleSubmit,
}) => (
  <div>
    <form
      onSubmit={e => {
        handleSubmit(e)
        e.preventDefault()
      }}
    >
      <Field isHorizontal={false} label="Username">
        <InputText
          name="username"
          type="text"
          value={values.username}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.username}
        />
      </Field>
      <Field isHorizontal={false} label="Password">
        <InputText
          name="password"
          type="password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.password}
        />
      </Field>
      <input
        type="submit"
        // onClick={handleSubmit}
        disabled={!isValid}
        className="button is-info is-fullwidth"
        value="SIGN IN"
      />
      {
        // <hr/>
        // <div className="has-text-centered">
        //   <small>โครงการ Innovation Hubs <br/>
        //   เพื่อสร้างเศรษฐกิจฐานนวัตกรรมของประเทศตามนโยบายประเทศไทย 4.0
        //   </small>
        // </div>
      }
    </form>
  </div>
)

export default compose(
  withFormik({
    mapPropsToValues: props => ({ username: '', password: '' }),
    handleSubmit: (values, { props }) => {
      // props.setInfo('passcode', values.passcode)
      // props.redirectToMenuPage()
      // const portalID = '5bd2b3709b78e82882a51c6b'
      // props.history.push(`${portalID}/info`)
      props.onSignin(values)
      // props.history.push('portals')
    },
    validate: values => {
      const errors = {}
      if (isEmpty(values.password)) errors.passcode = 'Required'
      return errors
    },
    isInitialValid: false,
  }),
)(SigninBox)



// WEBPACK FOOTER //
// ./src/components/templates/signin/SigninBox.js